// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "sequence".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
/** Response atom for the "sequence" table (1:1 with a DB row, on the wire). */
export const sequenceAtomSchema = z.object({
    id: z.string(),
    organizationId: z.string(),
    name: z.string(),
    description: z.string().nullable(),
    isActive: z.boolean().nullable(),
    triggerOnNewLead: z.boolean().nullable(),
    scheduleNextDay: z.boolean().nullable(),
    setupCompleted: z.boolean(),
    nodes: z.unknown().nullable(),
    edges: z.unknown().nullable(),
    settings: z.unknown().nullable(),
    createdById: z.string().nullable(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
    deletedAt: z.string().datetime().nullable(),
});
//# sourceMappingURL=sequence.js.map